
export default (https) => ({
  // Cost lines on a PO
  async costs(purchaseId) {
    const r = await https.get(`/purchases/${purchaseId}/costs`);
    return r.data;
  },
  async addCost(purchaseId, payload) {
    const r = await https.post(`/purchases/${purchaseId}/costs`, payload);
    return r.data;
  },
  async updateCost(purchaseId, costId, payload) {
    const r = await https.put(`/purchases/${purchaseId}/costs/${costId}`, payload);
    return r.data;
  },
  async deleteCost(purchaseId, costId) {
    const r = await https.delete(`/purchases/${purchaseId}/costs/${costId}`);
    return r.data;
  },
  // Per-line cbm/weight (drives CBM/weight allocation), recomputes on save
  async updateLineDims(purchaseId, lineId, payload) {
    const r = await https.put(`/purchases/${purchaseId}/lines/${lineId}`, payload);
    return r.data;
  },
  async recompute(purchaseId) {
    const r = await https.post(`/purchases/${purchaseId}/landed-cost/recompute`);
    return r.data;
  },
  // Full breakdown: lines (with landed cost) + cost lines + totals
  async breakdown(purchaseId) {
    const r = await https.get(`/purchases/${purchaseId}/landed-cost`);
    return r.data;
  },
  // Landed-cost trend for a product
  async costHistory(productId) {
    const r = await https.get(`/products/${productId}/cost-history`);
    return r.data;
  },
});
